export const handleFormatDateForTimezone = (dateTime: number) => {
  const date = new Date(dateTime)

  const dateMinus3Hours = new Date(date.getTime() - 3 * 60 * 60 * 1000)

  return dateMinus3Hours.getTime()
}
